import { CircleInfoIcon } from "@xola/icons";
import { Checkbox, Tooltip } from "@xola/ui-kit";
import React, { ChangeEvent } from "react";

interface NotifyCustomerCheckboxProps {
    isChecked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const NotifyCustomerCheckbox = ({ isChecked, onChange }: NotifyCustomerCheckboxProps) => {
    return (
        <div className="flex items-center">
            <Checkbox
                data-testid="notify-customer-checkbox"
                checked={isChecked}
                label="Notify Customer"
                onChange={onChange}
            />

            <Tooltip content="Customers with valid contact information will be contacted" className="ml-2">
                <CircleInfoIcon />
            </Tooltip>
        </div>
    );
};
